import React from 'react';

import LoadingImageSrc from '../../assets/gif/loading.gif';

import { useSelector } from 'react-redux';
import './index.css';

function LoadingModal() {

  const loading = useSelector(state => state.loading);

  return (
    <div className="loading-image-box" style={{ display: loading.show ? 'block' : 'none' }}>
      <div>
        <img alt="Loading" src={LoadingImageSrc} />
      </div>
    </div>
  )
}

export default LoadingModal;
